module.exports = __webpack_public_path__ + "img/p4-2-2.1d061bb2.png";